////////////////////////////////////////////////////////////////////////////////////////////////////
// Our Users

import { API } from 'aws-amplify';
import * as Queries from '@/graphql/queries';
import * as Mutations from '@/graphql/mutations';

const R = require( 'ramda' );

const {
    always,
    keys,
    path,
    pick,
} = R;

// Must contain only the fields in the User table
const emptyUser = always( {
    username : '',  // Cannot be changed
    email : '',     // Cannot be changed
    name : '',
    city : '',
    company : '',
    department : '',
    post : '',
    phone : '',

    privileges : [],
    tndAccountLoginIds : [],
} );

const apiGetUser = username => {
    const params = {
        query : Queries.getUser,
        variables : { username }, 
    };

    return API.graphql( params ).then( path( ['data', 'getUser'] ) );
};

const apiCreateUser = async user => {
    const newUser = pick( keys( emptyUser() ), user );

    const params = {
        query : Mutations.createUser,
        variables : { input : newUser },
    };

    console.log( `Creating user ${newUser.username}` );

    return await API.graphql( params );
};

const apiUpdateUser = user => {
    const updatedUser = pick( keys( emptyUser() ), user );

    const params = {
        query : Mutations.updateUser,
        variables : { input : updatedUser }
    };

    API.graphql( params ).catch( error => {
        console.log( `Error updating user ${updatedUser.username}`, updatedUser, error );
    } );

    // No need to return the updated user, the changes to the
    // GUI will happen through the subscription
};

const apiDeleteUser = async user => {
    const params = {
        query : Mutations.deleteUser,
        variables : { input : { username : user.username } }
    };

    API.graphql( params ).catch( error => {
        console.log( `Error deleting  user ${user.username}`, user, error );
    } );
};

export {
    emptyUser,
    apiGetUser,
    apiCreateUser,
    apiUpdateUser,
    apiDeleteUser,
};
